import {
  WarehouseLocationFeature,
  ICPlatformVersion,
} from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const InsightsPortalStoreLaborPerformanceAccessControl: DomainAccessControlConfig = [
  {
    warehouseLocationFeatures: WarehouseLocationFeature.RetailerPickup,
    permissions: Permission.Analytics,
  },
  {
    warehouseLocationFeatures: WarehouseLocationFeature.RetailerPickup,
    permissions: Permission.PickupAnalytics,
  },
]
